export const GAS_FEE_PROVIDER = 'provider';
export const GAS_FEE_METASWAP = 'metaswap';
export const GAS_FEE_ETHERSCAN = 'etherscan';
export const GAS_FEE_ETHGASSTATION = 'ethergasstation';

export const GAS_FEE_TYPE_LONDON = 'london';
export const GAS_FEE_TYPE_LEGACY = 'legacy';